/* global google */

export default {
  doClass () {
    /**
     * A customized popup on the map.
     * @param {!google.maps.LatLng} position
     * @param {!Element} content
     * @constructor
     * @extends {google.maps.OverlayView}
     */
    function Popup (position, content) {
      this.visible = false
      this.mounted = false
    }

    // NOTE: google.maps.OverlayView is only defined once the Maps API has
    // loaded. That is why Popup is defined inside initMap().
    Popup.prototype = Object.create(google.maps.OverlayView.prototype)

    /** Called when the popup is added to the map. */
    Popup.prototype.onAdd = function () {
      // this.getPanes().floatPane.appendChild(this.anchor)
    }

    /** Called when the popup is removed from the map. */
    Popup.prototype.onRemove = function () {
      if (this.anchor.parentElement) {
        this.anchor.parentElement.removeChild(this.anchor)
      }
    }

    /** Called when the popup needs to draw itself. */
    Popup.prototype.draw = function () {
      if (!this.visible) {
        return
      }

      let divPosition = this.getProjection().fromLatLngToDivPixel(this.position)

      // Hide the popup when it is far out of view.
      let display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none'

      if (display === 'block') {
        this.anchor.style.left = (divPosition.x - this.anchor.offsetWidth / 2) + 'px'
        this.anchor.style.top = (divPosition.y - this.anchor.offsetHeight - 12) + 'px'
      }
      if (this.anchor.style.display !== display) {
        this.anchor.style.display = display
      }
    }

    /** Stops clicks/drags from bubbling up to the map. */
    Popup.prototype.stopEventPropagation = function () {
      let anchor = this.anchor
      anchor.style.cursor = 'auto';

      ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
        'pointerdown']
        .forEach(function (event) {
          anchor.addEventListener(event, function (e) {
            e.stopPropagation()
          })
        })
    }

    Popup.prototype.mount = function () {
      this.title = document.createElement('div')
      this.title.classList.add('popup-bubble-content-title')

      this.statLabel = document.createElement('span')
      this.statLabel.classList.add('popup-bubble-content-stat-label')

      this.statValue = document.createElement('span')
      this.statValue.classList.add('popup-bubble-content-stat-value')
      this.statLabel.appendChild(this.statValue)

      let stat = document.createElement('div')
      stat.classList.add('popup-bubble-content-stat')
      stat.appendChild(this.statLabel)
      stat.appendChild(this.statValue)

      this.content = document.createElement('div')
      this.content.classList.add('popup-bubble-content')
      this.content.appendChild(this.title)
      this.content.appendChild(stat)

      let pixelOffset = document.createElement('div')
      pixelOffset.classList.add('popup-bubble-anchor')
      pixelOffset.appendChild(this.content)

      this.anchor = document.createElement('div')
      this.anchor.classList.add('popup-tip-anchor')
      this.anchor.style.position = 'absolute'
      this.anchor.style.pointerEvents = 'none'
      this.anchor.appendChild(pixelOffset)

      // Add to map
      this.getPanes().floatPane.appendChild(this.anchor)

      // Optionally stop clicks, etc., from bubbling up to the map.
      this.stopEventPropagation()

      this.mounted = true
    }

    Popup.prototype.show = function (id, position, title, statLabel, statValue) {
      if (this.id === id) {
        return
      }

      if (!this.mounted) {
        this.mount()
      }

      this.id = id
      this.position = new google.maps.LatLng(position)
      this.visible = true

      this.title.innerHTML = title
      this.statLabel.innerHTML = statLabel + ': '
      this.statValue.innerHTML = statValue
      this.draw()
    }

    Popup.prototype.hide = function () {
      this.visible = false
      this.anchor.style.display = 'none'
    }

    return Popup
  }
}



// WEBPACK FOOTER //
// ./src/classes/Popup.js